export const CONTRIBUTION = "CONTRIBUTION";
export const CONTRIBUTION_ERROR = "CONTRIBUTION_ERROR";
export const CONTRIBUTION_HIDE_ERROR = "CONTRIBUTION_HIDE_ERROR";
export const CONTRIBUTION_START_LOADER = "CONTRIBUTION_START_LOADER";
export const CONTRIBUTION_STOP_LOADER = "CONTRIBUTION_STOP_LOADER";
